import React from "react";
import PropTypes from "prop-types";
import glamorous from "glamorous";
import { Card, CardText } from "react-toolbox/lib/card";
import ButtonLink from "../../../../common/components/ButtonLink";
import TextBlock from "../../../../common/components/TextBlock";
import objectToArray from "../../../../common/utils/object-to-array";
import { urlResolver } from "../../../../common/utils/resolvers";
import styles from "../Onboarding/Steps/Header/styles.css";
import LogoImage from "../Onboarding/Steps/Header/nfib-logo.png";

const Text = glamorous.p({
  "& + &": {
    marginTop: "2rem"
  }
});

const Title = glamorous.h5({
  fontSize: "2.4rem",
  fontWeight: 400,
  marginBottom: "0.6rem"
});

const ThemedCard = ({
  className,
  bodyTitle,
  bodyText = "",
  pageColor,
  actions = {},
  url
}) => {
  return (
    <div>
      { url && url.includes("onboarding") ? (<div>
        <Card {...{ className }} style={{ boxShadow: "none", textAlign: "left", marginBottom: "2px" }}>
        <CardText>
          <h1 style={{fontSize:"20px"}}>Thank You</h1>
          <a style={{float:"right"}} href={"/account"}>My Profile</a>
          <TextBlock
            style={{
              padding: "1rem 0 0",
              fontSize: "1.7rem"
            }}
            component={Text}
          >
            {bodyText}
          </TextBlock>
        </CardText>
        
      </Card>
      <div style={{minHeight:"250px"}}>
        <Card className={styles['thankyou-card']} style={{minHeight:"185px"}}>
        <CardText>
          <p style={{
            margin:"auto",
          fontSize: "2.5rem",
          maxWidth:"240px"

        }}>Make your voice heard now</p>
        </CardText>
        <div style={{height:"45px"}}>
          <ButtonLink style={{padding:"15px",position: "absolute",bottom: "20px",left:"calc(50% - 78px)"}} label={"Vote My Ballot"} to={"/account/surveys"}></ButtonLink>
        </div>
        <hr style={{
          background: "#00AD50",
          position: "absolute",
          width: "100%",
          height: "3px",
          bottom: "0px",
          left: "0px"
        }}/>
      </Card>
        <Card className={styles['thankyou-card']} style={{marginLeft:"10%",minHeight:"185px"}}>
        <CardText>
          <p style={{
                      margin:"auto",
          fontSize: "2.5rem",
          maxWidth:"240px"

        }}>Download your free small business trends report</p>
        </CardText>
        <div style={{height:"45px"}}>
          <ButtonLink  style={{padding:"15px",position: "absolute",bottom: "20px",left:"calc(50% - 78px)"}} label={"SBET Download"} to={"https://www.nfib.com/surveys/small-business-economic-trends/"}></ButtonLink>
        </div>
        <hr style={{
          background: "#00AD50",
          position: "absolute",
          width: "100%",
          height: "3px",
          bottom: "0px",
          left: "0px"
        }}/>
      </Card>
      </div>
      </div>) : (<div>
            <nav>
        <a href="http://www.nfib.com/">
          <img src={LogoImage} className={styles.logo} alt="NFIB Logo" />
        </a>
      </nav>
        <Card {...{ className }} style={{ boxShadow: "none", textAlign: "left" }}>
        <CardText>
          {bodyTitle ? <Title>{bodyTitle}</Title> : null}
            <TextBlock
            style={{
              padding: "1rem 0 3rem",
              fontSize: "1.7rem"
            }}
            component={Text}
          >
            {bodyText}
          </TextBlock>
          {objectToArray(actions).map(action => {
            return (
              <div>
                <ButtonLink {...action} to={urlResolver(action.to)} />
                <br />
                <br />
              </div>
            );
          })} 

        </CardText>
      </Card>
      </div>) }
    </div>
  );
};
ThemedCard.propTypes = {
  bodyTitle: PropTypes.string,
  bodyText: PropTypes.string,
  pageColor: PropTypes.shape({ value: PropTypes.string }),
  actions: PropTypes.objectOf(
    PropTypes.shape({
      to: PropTypes.string
    })
  )
};

export default ThemedCard;



// WEBPACK FOOTER //
// ./src/App/account/components/ThemedCard/index.js